import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';
import { getIsMESEnabled } from './getIsMESEnabled';

// The NATS labor flow (labor ticket as source of truth, no activity-set
// polling) only applies to MES-enabled machines. A company can enable
// postLaborUpdatesOnNats while individual machines remain non-MES; those
// machines have no labor tickets and must keep polling activity sets and
// loading normally. Gate on machine-level MES so non-MES machines are never
// pushed into the NATS flow. See getIsMESEnabled (company AND machine mesEnabled).
const getPostLaborUpdatesOnNats = createSelector(
  [getCompanySettings, getIsMESEnabled],
  (companySettings, isMESEnabled) => {
    return !!companySettings?.postLaborUpdatesOnNats && isMESEnabled;
  }
);

export { getPostLaborUpdatesOnNats };
